import { render, staticRenderFns } from "./PatientSignup.vue?vue&type=template&id=a3f826ee&scoped=true&"
import script from "./PatientSignup.vue?vue&type=script&lang=js&"
export * from "./PatientSignup.vue?vue&type=script&lang=js&"
import style0 from "./PatientSignup.vue?vue&type=style&index=0&id=a3f826ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f826ee",
  null
  
)

export default component.exports